// const extend = require(`extend`);
// const Q = require(`q`);
const _ = require(`underscore`);
// const moment = require(`moment`);

//获取指定node以上（包括自己）的所有父node的列表
const get_parent_node_list = function ({node, property_name_for_parent = `parent`}) {

    const list = [];
    let stack = [
        node,
    ];

    while (stack.length > 0) {
        const current_stack = stack.shift();
        list.push(current_stack);

        const parent = current_stack[property_name_for_parent];
        if (!parent) continue;
        if (parent.level <= 0) continue;

        stack = stack.concat(parent);
    }

    return list;

};

module.exports = get_parent_node_list;
